import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)<{
  backgroundImage: string;
  background: 'dark-solid' | 'light-solid' | 'gradient';
}>`
  --background: url(${(props) => props.backgroundImage}) center/cover no-repeat;

  .content-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 48px 16px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
  }
`;

export const ChatContainerStyles = styled.div`
  position: absolute;
  top: 80px;
  left: 16px;
  right: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AnimatedBottomButtonContainer = styled.div<{ show: boolean }>`
  position: fixed;
  bottom: 34px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: 500px;
  width: 100%;
  padding: 0 16px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) =>
    show
      ? 'translateX(-50%) translateY(0)'
      : 'translateX(-50%) translateY(100px)'};
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
`;
